import { connect } from 'react-redux';

import authSelectors from '_store/_selectors/auth';
import chargesActionCreators from '_store/_actions/charges';

import ChargesDashboard from './ChargesDashboard';

const mapStateToProps = state => ({
  user: authSelectors.currentUserSelector(state),
  activeCompany: state.company.activeCompany,
  chargesDashboard: state.companyCharges.dashboardData,
  isLoading: state.companyCharges.dashboardLoading,
});

const mapDispatchToProps = {
  onFetchChargesDashboard: chargesActionCreators.fetchChargesSummaryDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargesDashboard);
